import {cs} from "@Common/react/chain-services";
import {ui} from "@Common/ui-components/heavy/item-options/modules/expo-types/expo-types";

import {PricingTableModal} from "../../../../../common/pricing-table-modal/pricing-table-modal";

import {DeliveryMethods} from "./delivery-methods";

export const deliveryMethodsModules = ({templateOptions, item}) => [
    {
        name: "pricingTableModal",
        load: ({variationsPricingTableModal}, loadNext) => cs(
            ["defaultModal", ({}, next) => PricingTableModal({templateOptions, next})],
            ({defaultModal}) => loadNext(variationsPricingTableModal ?? defaultModal),
        ),
        requires: ["variationsPricingTableModal"],
    },

    {
        load: ({deliveryMethod1, pricingTableModal}, next) => next({
            ui: DeliveryMethods({
                pricingTableModal,
                state: deliveryMethod1.ui,
                avaiMethods: (
                    templateOptions.distributions
                        .filter((method) => method !== "pickup" || item?.programType !== "Scheduled Campaigns")
                ),
            }),
        }),
        expo: [ui("deliveryMethod")],
        requires: ["deliveryMethod1", "pricingTableModal"],
    },
];

